import $ from "jquery";

export default {
    data() {
        return {};
    },
    methods: {
        updateModalInfos($event) {

            let jobName = $($event.target).closest(".slide").find(".titre").html()
            let idOffre = $($event.target).data("id")

            $("#input_3_7").val(idOffre)
            $("#input_3_10").val(jobName)

            $("#modal-candidature .titre-poste").html(jobName)
            // this.$refs['modal-job'].reInit($($event.target).data('id'), spontane)
        },
        initForm() {
            console.log("init forms")

            $(".ginput_container_fileupload").prepend(`
            <div class="fake-input">
                <span class="label"></span>
                <span class="icon-paperclip"></span>
                <span class="icon-plus"></span>
            </div>
            `);

            $("input[type=\"file\"]").bind("change", function ($event) {
                let $target = $($event.currentTarget)
                let filename = $event.currentTarget.files[0].name
                $target.closest(".ginput_container").find(".fake-input .label").html(filename)
                // $("#img_text").html($('input[type="file"]').val());
            });


        }

    },
    mounted() {
/*        if ($("body").hasClass("post-type-archive-offre")) {
            this.initForm()
        }*/
    }
};